import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { SaveRefusal } from '../../lib/payPolicyTemplates/api';

interface SaveRefusalDialogProps {
  refusal: SaveRefusal | null;
  open: boolean;
  onClose: () => void;
}

/** Why day-pay-policies or Global Calculations refused the template, in full rather than one line. */
const SaveRefusalDialog = ({ refusal, open, onClose }: SaveRefusalDialogProps) => (
  <Dialog open={open && refusal !== null} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderTop: 6, borderColor: 'error.main' } }}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main' }}>
      <ErrorOutlineIcon color="error" />
      The template was not saved
    </DialogTitle>
    {refusal && (
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          {refusal.summary}
        </Alert>
        {refusal.detail && <DialogContentText sx={{ mb: 2, color: 'text.primary' }}>{refusal.detail}</DialogContentText>}
        {refusal.reasons.length > 0 && (
          <Box component="ul" sx={{ mt: 0, mb: 2, pl: 2.5 }}>
            {refusal.reasons.map((reason) => (
              <li key={reason}>
                <Typography variant="body2">{reason}</Typography>
              </li>
            ))}
          </Box>
        )}
        {refusal.code && (
          <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
            {refusal.code}
          </Typography>
        )}
      </DialogContent>
    )}
    <DialogActions>
      <Button variant="contained" onClick={onClose} autoFocus>
        Back to the template
      </Button>
    </DialogActions>
  </Dialog>
);

export default SaveRefusalDialog;
